import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Emphasis from '../../components/Emphasis';
import Typography from '../../components/Typography';
import { Button } from '@material-ui/core';
import CallUs from './CallUs';
import Image from '../../components/Image';

const styles = theme => ({
  root: {
    textAlign: 'center',
    padding: '3rem 1rem',
    [theme.breakpoints.up('md')]: {
      marginTop: '4rem'
    }
  },
  button: {
    fontWeight: '900',
    boxShadow: '0 30px 30px -10px rgba(0,0,0,0.3)',
    padding: '1rem 0',
    margin: '2px 0 12px 0',
    letterSpacing: '2px',
    lineHeight: '28px'
  },
  arrow: {
    transform: 'rotate(-90deg)',
    cursor: 'pointer',
    marginTop: '3rem'
  },
  // (000-341): 2.5 + 3 (takes whole row)
  // [341-768): 3 + 4 (takes whole row)
  // [768-900): 2.5 + 3.5 (takes 1/3 row)
  // [900-960): 3 + 4 (takes 1/3 row)
  // [961-xxx): 4 + 5.5 (takes 1/3 row)
  title: {
    fontSize: '4rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '3rem'
    },
    [theme.breakpoints.down('900')]: {
      fontSize: '2.5rem'
    },
    [theme.breakpoints.down('768')]: {
      fontSize: '3rem'
    },
    [theme.breakpoints.down('341')]: {
      fontSize: '2.5rem'
    }
  },
  emphasis: {
    fontSize: '5.5rem',
    color: theme.palette.primary.main,
    lineHeight: 1,
    letterSpacing: -1.32,
    fontFamily: 'BornReady-Slanted',
    [theme.breakpoints.down('sm')]: {
      fontSize: '4rem'
    },
    [theme.breakpoints.down('900')]: {
      fontSize: '3.5rem'
    },
    [theme.breakpoints.down('768')]: {
      fontSize: '4rem'
    },
    [theme.breakpoints.down('341')]: {
      fontSize: '3rem'
    }
  }
});

class LeadContainer extends React.Component {
  render() {
    const { classes, callbackPricing, callbackComparison } = this.props;

    return (
      <div className={`${classes.root} padding-xs`}>
        <Typography bold={true} variant="subtitle1" color="primary">
          LEARN THE BENEFITS
        </Typography>
        <Typography variant="h1" className={classes.title}>
          Membership Pricing&nbsp;
          <Emphasis className={classes.emphasis}>Plans</Emphasis>
        </Typography>
        <Typography style={{ marginBottom: '15px', textAlign: 'left' }}>
          Make your home a reality. Save up to 50% off retail on everything from
          home furnishings and lighting to mattresses and more.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth={true}
          onClick={callbackPricing}
          className={classes.button}
        >
          CHOOSE YOUR PRICING PLAN
        </Button>
        <CallUs primary={false} />
        <Image
          src="/homepage/arrow basic.svg"
          className={classes.arrow}
          onClick={callbackComparison}
        />
      </div>
    );
  }
}

LeadContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  callbackPricing: PropTypes.func.isRequired,
  callbackComparison: PropTypes.func.isRequired
};

export default withStyles(styles)(LeadContainer);
